// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwComponentSectionConfigPreference } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleMapConfig } from '../models/google-map-config.model';
import { GoogleMapConfigComponent } from './google-map-config/google-map-config.component';


@DwComponent({
  name: 'GoogleMap',
  isGlobal: true,
  componentType: DwComponentType.formSection,
  configComponent : GoogleMapConfigComponent
})
@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent
  extends DwSectionBaseComponent<DwComponentSectionConfigPreference<GoogleMapConfig>> implements OnInit {

  lon: number;
  lat: number;
  markers: any;

  @ViewChild('GoogleMap') templateSelect: DwSelectLookupComponent;
  isConfigComplete = false;

  googleMapConfig: GoogleMapConfig;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,

    private messageService: DwMessagingService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.markers = [];

    this.googleMapConfig = this.sectionConfig.config;

    if (this.googleMapConfig && this.googleMapConfig.latitudeAttr && this.googleMapConfig.longitudeAttr) {
      this.isConfigComplete = true;

        this.formGroup.valueChanges.subscribe(value => {
          const latValue = this.getAttributeValue(this.googleMapConfig.latitudeAttr);
          const longValue = this.getAttributeValue(this.googleMapConfig.longitudeAttr);

          if (latValue != null && longValue != null) {
            const templateDisplay = this.googleMapConfig.displayTemplate;

            const oldDisplay = this.formGroup.get('FirstName').value + ' ' + this.formGroup.get('LastName').value;

            this.addMarker(latValue, longValue, templateDisplay);
          }
        }
      );
    }
  }

  getAttributeValue(attrName: string) {
    const control = this.formGroup.get(attrName);

    if (!control) {
      console.warn(`Attribute ${attrName} as not found in the form group!`);
      return `${attrName} not found`;
    }

    return control.value;
  }

  addMarker(lat: number, lon: number, marketDisplay: string) {
    this.markers = {
      position: {
        lat: lat,
        lng: lon,
      },
      label: {
        color: this.googleMapConfig.color,
        text: marketDisplay,
      },
      title: marketDisplay,
      options: { animation: google.maps.Animation.DROP },
    };
  }

}
